// extracted by mini-css-extract-plugin
export default {"imgWidth":"EquipmentSpecfication_imgWidth__B89Ua"};